import { BrandOverlayEntityRaw } from "@common/domain";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { RoomBrandOverlayEvents } from "../events";
import { RoomBrandOverlayActions } from "../actions";

export const ROOM_BRAND_OVERLAY_FEATURE_KEY = "roomBrandOverlay";

export interface RoomBrandOverlayState
  extends EntityState<Record<string, never>> {
  isLoading: boolean;
  brandOverlay: null | BrandOverlayEntityRaw;
}

export const roomBrandOverlayAdapter: EntityAdapter<Record<string, never>> =
  createEntityAdapter();

const initialState: RoomBrandOverlayState =
  roomBrandOverlayAdapter.getInitialState({
    isLoading: false,
    brandOverlay: null
  });

const reducer = createReducer(
  initialState,
  on(RoomBrandOverlayActions.roomBrandOverlayCreate, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayCreateSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayCreateFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayDelete, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayDeleteSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayDeleteFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayUnUse, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayUnUseSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayUnUseFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayUse, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayUseSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandOverlayActions.roomBrandOverlayUseFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandOverlayEvents.roomBrandOverlayDeleteEvent, (state) => ({
    ...state,
    brandOverlay: null
  })),
  on(
    RoomBrandOverlayEvents.roomBrandOverlaySetEvent,
    (state, { roomBrandOverlaySetEventVO }) => ({
      ...state,
      brandOverlay: roomBrandOverlaySetEventVO.value.brandOverlay.toJSON()
    })
  )
);

export function roomBrandOverlayReducer(
  state: RoomBrandOverlayState | undefined,
  action: Action
) {
  return reducer(state, action);
}
